import {useStyles} from '../../../../shared/hooks/styles';

export default () =>
  useStyles(({isDesktop, theme, addShadow}) => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      width: isDesktop ? 315 : '100%',
      paddingBottom: 36,
      backgroundColor: theme.color.white,
      borderRadius: 24,
      ...addShadow({
        width: 0,
        height: 2,
        radius: 8,
        opacity: 0.08,
        color: theme.color.black,
        elevation: 10,
      }),
    },
    logo: {
      position: 'relative',
      zIndex: 1,
      width: 180,
      height: 180,
      marginTop: 20,
      marginBottom: 20,
    },
    text: {
      ...theme.fonts.h5,
      color: theme.color.gray700,
      textAlign: 'center',
    },
    icon: {
      width: 18,
      height: 18,
      color: theme.color.blue300,
    },
    phone: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 25,
      marginBottom: 20,
    },
    phoneText: {
      ...theme.fonts.body,
      marginLeft: 10,
      color: theme.color.gray700,
    },
    button: {width: 200},
  }));
